﻿import React, {Component} from 'react';
import { browserHistory } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import { renderSelectField, renderSwitchField, renderTextField } from '../../components/core/editors';
import { connect } from 'react-redux';
import NavigationBack from 'material-ui/svg-icons/navigation/arrow-back';
import {Paper, Dialog, FlatButton, MenuItem, Subheader, IconButton, AppBar, CircularProgress, LinearProgress, RaisedButton} from 'material-ui';
import service from '../../services/role-services';

class RoleDetails extends Component {
    constructor(props, context) {
        super(props, context);

        this.onBackToList = this.onBackToList.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
        this.handleDeleteClose = this.handleDeleteClose.bind(this);
        this.deleteConfirmed = this.deleteConfirmed.bind(this);

        this.roleId = context.router.params.roleId;
    }

    componentDidMount() {
        this.props.onGetRole(this.roleId);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    submitForm(data) {
        this.props.onSubmitRole(data);
    }

    onDeleteConfirm() {
        this.props.onConfirmDeleteRole(true);
    }

    handleDeleteClose() {
        this.props.onConfirmDeleteRole(false);
    }

    deleteConfirmed() {
        this.props.onDeleteRole(this.roleId);
    }

    onBackToList() {
        browserHistory.goBack();
    }

    render() {

        const { handleSubmit, pristine, submitting, inProgress, saving, openDeleteDialog } = this.props;

        if (inProgress) {
            return (
                <div>
                    <AppBar title="Role editor"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}
                            iconElementRight={<FlatButton label="Save" type="submit" disabled={pristine || submitting}/>}
                    />
                    <div style={{margin: 100}}>
                        <CircularProgress size={100} thickness={5}/>
                    </div>
                </div>
            )
        }

        const deleteActions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleDeleteClose}
            />,
            <FlatButton
                label="Delete"
                secondary={true}
                keyboardFocused={true}
                onTouchTap={this.deleteConfirmed}
            />,
        ];

        return (
            <div>
                <form onSubmit={handleSubmit(this.submitForm)} noValidate={true} >
                    <AppBar title="Role editor"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}
                            iconElementRight={<FlatButton label="Save" type="submit" />}
                    />

                    <Paper className="template-edit-form" zDepth={1}>
                        { saving ? <LinearProgress mode="indeterminate"/> : null }

                        <Field name="Id" type="hidden" component={renderTextField} label="Id"  />
                        <Field required name="RoleName" component={renderTextField} label="Role Name" tooltip="Human readable role name" />

                        <Subheader>Categories And Counties Permissions</Subheader>
                        <Field type="number" required name="CountiesAllowed" component={renderTextField} label="Counties Allowed"
                               tooltip={<span>Number of counties a user is allowed to subscribe to.<br/> Value indicates how many counties are allowed <br/> 0 - Unlimited <br/>1..n - Max Counties</span>}/>

                        <Field required name="FireHazmat" component={renderSwitchField} label="Fire Hazmat" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="PoliceCrime" component={renderSwitchField} label="Police Crime" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="RescueTrauma" component={renderSwitchField} label="Rescue Trauma" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="Traffic" component={renderSwitchField} label="Traffic" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="SmokeWater" component={renderSwitchField} label="Smoke Water" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="Weather" component={renderSwitchField} label="Weather" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="ThirdAlarm" component={renderSwitchField} label="Third Alarm" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="National" component={renderSwitchField} label="National" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="International" component={renderSwitchField} label="International" tooltip={<span>Allow a user to receive incidents from this category</span>}/>
                        <Field required name="Local" component={renderSwitchField} label="Local" tooltip={<span>Allow a user to receive incidents from this category</span>}/>

                        <Subheader>Webview Visible Windows Permissions</Subheader>
                        <Field required name="WindowSendJob" component={renderSwitchField} label="Send Job Window" tooltip={<span>Displays the send job window</span>}/>
                        <Field required name="WindowBlog" component={renderSwitchField} label="Blog Window" tooltip={<span>Displays the blog send action in incident history window</span>}/>
                        <Field required name="WindowAdmin" component={renderSwitchField} label="Admin Window" tooltip={<span>Displays the admin window</span>}/>
                        <Field required name="WindowResources" component={renderSwitchField} label="Resources Window" tooltip={<span>Displays resources window</span>}/>
                        <Field required name="WindowMessaging" component={renderSwitchField} label="Messaging Window" tooltip={<span>Displays messaging window</span>}/>
                        <Field required name="WindowRist" component={renderSwitchField} label="RIST Window" tooltip={<span>Displays RIST window</span>}/>
                        <Field required name="WindowSendJobFreeForm" component={renderSwitchField} label="Send Job Free Form" tooltip={<span>Displays free-form send job window</span>}/>
                        <Field required name="TabEmail" component={renderSwitchField} label="Email Window" tooltip={<span>Displays email tab</span>}/>
                        <Field required name="WindowVmMediaTips" component={renderSwitchField} label="TVM Window" tooltip={<span>Displays voice mail, media, tips window</span>}/>
                        <Field required name="WindowSearch" component={renderSwitchField} label="Search Window" tooltip={<span>Allow to see Search tab in webview</span>}/>
                        <Field required name="WindowHistory" component={renderSwitchField} label="History Window" tooltip={<span>Allow to see History tab in webview</span>}/>
                        <Field required name="WindowProfile" component={renderSwitchField} label="Profile Window" tooltip={<span>Allow to see Profile window</span>}/>
                        <Field required name="WindowMemberStats" component={renderSwitchField} label="Member Stats Window" tooltip={<span>Member Statistics window (not used yet)</span>}/>
                        <Field required name="WindowSendJobIntl" component={renderSwitchField} label="Send Job Intl. Window" tooltip={<span>Not Used</span>}/>

                        <Subheader>Webview Send Job Permissions</Subheader>
                        <Field required name="SendIncident" component={renderSelectField} label="Send Incident"
                               tooltip={<span>Allow send job. Each level also allows everything below, so a 3 will also allow 1 and 2, etc</span>}>
                            <MenuItem value={0} primaryText="None"/>
                            <MenuItem value={1} primaryText="Minor"/>
                            <MenuItem value={2} primaryText="Routine"/>
                            <MenuItem value={3} primaryText="Major"/>
                            <MenuItem value={4} primaryText="Local News"/>
                            <MenuItem value={5} primaryText="National"/>
                            <MenuItem value={6} primaryText="International"/>
                            <MenuItem value={9} primaryText="All"/>
                        </Field>
                        <Field required name="SendConfirm" component={renderSwitchField} label="Send Confirm" tooltip={<span>Dialog confirming send before major, national, international, fatal, medivac</span>}/>
                        <Field required name="ApproveMedia" component={renderSwitchField} label="Approve Media" tooltip={<span>Allow user to approve media submissions</span>}/>
                        <Field required name="ApproveIncident" component={renderSwitchField} label="Approve Incident" tooltip={<span>Allow user to approve incidents</span>}/>
                        <Field required name="GetMediaLevel" component={renderSelectField} label="Get Media Level" tooltip={<span>Filters approval queue by type</span>}>
                            <MenuItem value={0} primaryText="Not Allow"/>
                            <MenuItem value={1} primaryText="Photos"/>
                            <MenuItem value={2} primaryText="Photos / Video"/>
                            <MenuItem value={3} primaryText="Photos / Video / Text"/>
                            <MenuItem value={4} primaryText="All Media"/>
                        </Field>
                        <Field required name="ClaimIncident" component={renderSwitchField} label="Claim Incident" tooltip={"Allow user to claim an incident"}/>
                        <Field required name="ConfiscateClaim" component={renderSwitchField} label="Confiscate Claim" tooltip={<span>Allow a user to confiscate an incident claimed by another user</span>}/>
                        <Field required name="ReleaseClaim" component={renderSwitchField} label="Release Claim" tooltip={<span>Allow a user to release an incident that was claimed by another member</span>}/>
                        <Field required name="SeeClaims" component={renderSwitchField} label="See Claims" tooltip={<span>Allow to see claims in incidents list</span>}/>
                        <Field required name="SendPreAlert" component={renderSwitchField} label="Send Pre Alert" tooltip={<span>Allow a user to send a pre-alert</span>}/>
                        <Field required name="SendBlog" component={renderSwitchField} label="Send Blog" tooltip={<span>Allow to send Incident With Blog type</span>}/>
                        <Field required name="FunctionVote" component={renderSwitchField} label="Allow Vote" tooltip={<span>Allow to see vote window and vote for Job</span>}/>
                        <Field required name="AllowStealth" component={renderSwitchField} label="Allow Stealth" tooltip={<span>Not used</span>}/>
                        <Field required name="CanDeleteMedia" component={renderSwitchField} label="Can Delete Media" tooltip={<span>Allows user to delete media</span>}/>
                        <Field required name="Incidents" component={renderSelectField} label="Incidents" tooltip={<span>Filter incidents in list</span>}>
                            <MenuItem value={0} primaryText="None"/>
                            <MenuItem value={1} primaryText="Filtered"/>
                            <MenuItem value={2} primaryText="Filtered / Unfiltered"/>
                        </Field>
                        <Field required name="FunctionEditProfile" component={renderSelectField} label="Allow Edit Profile" tooltip={<span>Allows user to edit his profile or anyone profile</span>}>
                            <MenuItem value={0} primaryText="Anyone"/>
                            <MenuItem value={1} primaryText="Own Only"/>
                        </Field>
                        <Field required name="FunctionSearchbyMemberId" component={renderSwitchField} label="Allow Search by Member Id" tooltip={<span>Allows user to search incidents using the member id field</span>}/>

                        <Subheader>Webview Chat / Messaging Permissions</Subheader>
                        <Field required name="BnnChat" component={renderSwitchField} label="Bnn Chat" tooltip={<span>Display main chat window</span>}/>
                        <Field required name="BnnTacRooms" component={renderSwitchField} label="Bnn Tac Rooms" tooltip={<span>Allow certain group chat rooms</span>}/>
                        <Field required name="ChatModerator" component={renderSwitchField} label="Chat Moderator" tooltip={<span>Allow user to kick, ban and other admin functions in chats</span>}/>
                        <Field required name="ConsolidatedChat" component={renderSwitchField} label="Consolidated Chat" tooltip={<span>Allows user to view all rooms messages in one window</span>}/>
                        <Field required name="Broadcast" component={renderSwitchField} label="Broadcast" tooltip={<span>Allows user to view all rooms messages in one window</span>}/>
                        <Field required name="FunctionTextMessage" component={renderSwitchField} label="Text Message Function" tooltip={<span>Allows user to send a message to an offline user or text message to online user</span>}/>
                        <Field required name="FunctionPvtChat" component={renderSwitchField} label="Pvt Chat Function" tooltip={<span>Allow user to use private chat</span>}/>

                        <Subheader>Webview User Details Permissions</Subheader>
                        <Field required name="HoverUserInfo" component={renderSelectField} label="Hover User Info" tooltip={<span>Used to filter user(member) info returned from API</span>}>
                            <MenuItem value={0} primaryText="All"/>
                            <MenuItem value={1} primaryText="Limited"/>
                            <MenuItem value={2} primaryText="None"/>
                        </Field>
                        <Field required name="IncludeInOul" component={renderSwitchField} label="Include In Oul" tooltip={<span>Include user in offline user list</span>}/>
                        <Field required name="IncludeInMessaging" component={renderSwitchField} label="Include In Messaging" tooltip={<span>Include user in messaging tree</span>}/>
                        <Field required name="MapMembers" component={renderSwitchField} label="Map Members" tooltip={<span>Allows user to see members on map</span>}/>
                        <Field required name="AlertMember" component={renderSwitchField} label="Alert Member" tooltip={<span>Allow a user to alert other users in chat</span>}/>

                        <Subheader>Other Permissions</Subheader>
                        <Field required name="AllowWebview" component={renderSwitchField} label="Allow Webview" tooltip={<span>Allow to use (login) to Webview</span>}/>
                        <Field required name="AllowChat" component={renderSelectField} label="Allow Chat" tooltip={<span>Allow to use chat on WebView</span>}>
                            <MenuItem value={0} primaryText="No Chats"/>
                            <MenuItem value={1} primaryText="Desk chat only"/>
                            <MenuItem value={2} primaryText="Any Chat"/>
                        </Field>

                        <RaisedButton label="Delete" secondary={true} onClick={this.onDeleteConfirm} style={{
                            margin: "auto",
                            marginTop: "50px",
                            marginBottom: "50px",
                            display: this.roleId > 0 ? "block" : "none",
                            width: "150px"
                        }} />

                    </Paper>
                </form>

                <Dialog
                    title="Delete Role?"
                    actions={deleteActions}
                    modal={false}
                    open={openDeleteDialog == undefined ? false : openDeleteDialog}
                    onRequestClose={this.handleDeleteClose}
                >
                    Are you sure you want to delete role?
                </Dialog>
            </div>
        );
    }
}

const validate = values => {
    const errors = {};
    const requiredFields = [ 'RoleName', 'CountiesAllowed' ];
    requiredFields.forEach(field => {
        if (!values[ field ] && values[field] !== 0) {
            errors[ field ] = 'Required';
        }
    });
    if (isNaN(Number(values.CountiesAllowed))) {
        errors.CountiesAllowed = 'Must be a number'
    } else if (Number(values.CountiesAllowed) < 0) {
        errors.CountiesAllowed = 'Sorry, value must be positive'
    }
    return errors;
};

const mapStateToProps = state => ({...state.roles});

const mapDispatchToProps = dispatch => ({
    onGetRole: (id) =>
        dispatch({type: 'REQUEST_ROLE', payload: id > 0 ? service.RoleServices.getRole(id) : {
            CountiesAllowed: 0,
            FunctionEditProfile: 1,
            GetMediaLevel: 0,
            HoverUserInfo: 2,
            Incidents: 0,
            SendIncident: 0,
        }}),
    onSubmitRole: (role) =>
        dispatch({type: 'SUBMIT_ROLE', payload: service.RoleServices.postRole(role)}),
    onConfirmDeleteRole: (open) =>
        dispatch({type: 'CONFIRM_DELETE_ROLE', payload: open}),
    onDeleteRole: (id) =>
        dispatch({type: 'DELETE_ROLE', payload: service.RoleServices.deleteRole(id)}),
    onUnload: () =>
        dispatch({type: 'ROLES_PAGE_UNLOADED'})
});

RoleDetails.contextTypes = {
    router: React.PropTypes.any.isRequired
};

RoleDetails = reduxForm({
    form: 'roleForm',
    enableReinitialize: true,
    validate
})(RoleDetails);

RoleDetails = connect(mapStateToProps, mapDispatchToProps)(RoleDetails);

export default RoleDetails;